export const ToggleEvents = {
  CHANGED: 'luds-toggle:changed',
  INFO_CLICKED: 'toggle-info-clicked',
} as const;
